// C:\Users\clint\f1-tipping-site\frontend\src\components\RacesList.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../utils/apiClient';

const RacesList = () => {
  const [races, setRaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchRaces = async () => {
      try {
        setLoading(true);
        
        // Use apiClient instead of axios with token handling
        const response = await apiClient.get('/api/f1data/races/all');
        
        setRaces(response.data);
      } catch (err) {
        console.error('Error fetching races:', err);
        setError('Failed to load races. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchRaces();
  }, []);
  
  const handleRaceSelect = (raceId) => {
    navigate(`/predictions/${raceId}`);
  };
  
  if (loading) {
    return <div className="text-center py-10">Loading races...</div>;
  }
  
  if (error) {
    return (
      <div className="max-w-4xl mx-auto p-4">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      </div>
    );
  }
  
  return (
    <div className="max-w-4xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Race Calendar</h1>
      
      {races.length === 0 ? (
        <p className="text-gray-500">No upcoming races found.</p>
      ) : (
        <div className="space-y-4">
          {races.map(race => (
            <div 
              key={race._id} 
              className="bg-white shadow rounded-lg p-4 cursor-pointer hover:bg-gray-50"
              onClick={() => handleRaceSelect(race._id)}
            >
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-semibold">{race.raceName}</h2>
                  <p className="text-gray-600">{new Date(race.date).toLocaleDateString()}</p>
                  <p className="text-sm text-gray-500">
                    {race.circuit?.name}, {race.circuit?.country}
                  </p>
                </div>
                <div>
                  {race.predictionsOpen ? (
                    <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded">
                      Predictions Open
                    </span>
                  ) : (
                    <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded">
                      Predictions Closed
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RacesList;